import { formatMonetary } from '../../../../../utils/format/FormatMonetary';
import { HeadCell } from '../../../interfaces/TableInterface';
import { FormatDate, FormatDateHours } from './functions/FormatDate';
import ViewAttributeBoolean from './functions/ViewAttributeBoolean';

const formatValues = (keys: HeadCell, value: string, row: any) => {
    if (keys.format?.includes('dateTime')) {
        value = FormatDateHours(row[keys.id]);
    }

    if (keys.format?.includes('date')) {
        value = FormatDate(row[keys.id]);
    }

    if (keys.format?.includes('monetary')) {
        value = formatMonetary(row[keys.id]);
    }

    if (keys.viewAttributeBoolean) {
        value = ViewAttributeBoolean(row[keys.id], keys.viewAttributeBoolean);
    }

    const values: any[] = keys.id.split('.');

    if (values.length > 1) {
        value = row[values[0]][values[1]]
    }

    return value;
}

export default formatValues;